import { render, staticRenderFns } from "./NavbarFrontend.vue?vue&type=template&id=1663e3f8&"
import script from "./NavbarFrontend.vue?vue&type=script&lang=js&"
export * from "./NavbarFrontend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports